// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const PaperPlane_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21.311 2.689a1.5 1.5 0 0 0-1.468-.383h-.014L1.835 7.766A1.5 1.5 0 0 0 1.6 10.56l7.962 3.877 3.871 7.957a1.49 1.49 0 0 0 1.354.856q.065 0 .13-.006a1.49 1.49 0 0 0 1.312-1.079l5.456-17.994v-.014a1.5 1.5 0 0 0-.375-1.468Zm-6.514 19.047-.005.013v-.007l-3.756-7.715 4.5-4.5a.75.75 0 0 0-1.06-1.06l-4.5 4.5L2.257 9.21h-.006.013L20.25 3.75Z',
  viewBox: '0 0 24 24',
  glyph: 'PaperPlane_Stroke2_Corner0_Rounded',
})

export const PaperPlaneVertical_Filled_Stroke2_Corner1_Rounded =
  createSinglePathSVG({
    path: 'M21.694 4.157v.014l-5.456 17.994a1.49 1.49 0 0 1-1.313 1.08q-.065.005-.13.005a1.49 1.49 0 0 1-1.351-.858L10.03 15.39a.375.375 0 0 1 .072-.43l5.43-5.43a.75.75 0 0 0-1.06-1.06L9.04 13.9a.375.375 0 0 1-.43.073L1.602 10.56a1.5 1.5 0 0 1 .234-2.794L19.829 2.31h.014a1.5 1.5 0 0 1 1.85 1.847Z',
    viewBox: '0 0 24 24',
    glyph: 'PaperPlaneVertical_Filled_Stroke2_Corner1_Rounded',
  })
